module.exports = __webpack_public_path__ + "img/Bubble Chart Analysis.92f74085.png";